import { render } from "./affiliate-assessment-entrepreneur.vue?vue&type=template&id=65741e88&scoped=true&ts=true"
import script from "./affiliate-assessment-entrepreneur.vue?vue&type=script&lang=ts"
export * from "./affiliate-assessment-entrepreneur.vue?vue&type=script&lang=ts"

import "./affiliate-assessment-entrepreneur.vue?vue&type=style&index=0&id=65741e88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65741e88"]])

export default __exports__